import { ITEM } from '../config/config';
import type { World } from '../game/world';
import { C } from '../gfx/palette';
import type { Renderer } from '../gfx/renderer';
import { moveBody } from '../world/physics';
import { Entity } from './entity';

/** The energy orb thrown by the Ember form: bounces along the ground. */
export class EnergyOrb extends Entity {
  readonly kind = 'orb' as const;
  private life = ITEM.orbLife;
  private anim = 0;

  constructor(x: number, y: number, dir: number) {
    super(x, y, 8, 8);
    this.vx = dir * ITEM.orbSpeed;
    this.facing = dir;
    this.alwaysAwake = true;
    this.awake = true;
    this.z = 2;
  }

  override update(dt: number, world: World): void {
    this.life -= dt;
    this.anim += dt;
    if (this.life <= 0) {
      this.pop(world);
      return;
    }
    this.vy = Math.min(this.vy + 900 * dt, 300);
    moveBody(this, world.map, dt, world.solidBoxes());
    if (this.onGround) this.vy = -ITEM.orbBounce;
    if (this.hitLeft || this.hitRight) {
      this.pop(world);
      return;
    }
    if (this.y > world.map.pixelH + 32) this.alive = false;
    // orbs also knock loose blocks they hit from below
    if (this.hitCeiling) this.pop(world);
  }

  pop(world: World): void {
    if (!this.alive) return;
    this.alive = false;
    world.particles.puff(this.centerX, this.centerY, C.emberLight, 6);
  }

  override draw(r: Renderer): void {
    const frame = Math.floor(this.anim * 22) % 4;
    r.sprite(`orb.${frame}`, this.x, this.y, this.facing > 0);
  }
}
